<template>
  <div>
    <!-- 民意收集页面 -->
    <div class="echart_zonglan">
      <div class="echarts_font">
        <img :src="icon_font"
             class="icon_img"
             alt="" />
        <span class="people_font">民意收集整体情况</span>
      </div>
      <div id="echart_cjt_one">
        <CollectionNum :dataList="this.totalData.feedbackStatisList" class="collection_line" />
        <div class="right_box">
          <div class="r_list"
               v-for="(item,index) in totalText" :key="index">
            <svg class="boder"
                 version="1.1"
                 id="Layer_1"
                 xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 x="0px"
                 y="0px"
                 width="100%"
                 height="100%"
                 viewBox="0 0 151 81"
                 enable-background="new 0 0 151 81"
                 xml:space="preserve">
              <image id="image0"
                     width="151"
                     height="81"
                     x="0"
                     y="0"
                     href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJcAAABRCAMAAADo8MTiAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAM1BMVEUAAAAN/f8N+/8R9voN
+v1Ix8cZ8PES+fsAqqoW8/YO+f0U8vUV8vIP+vwO/P8N/P////+5zx3vAAAADnRSTlMAdIzQjUCX
zwOs5Uw9nSd6A3MAAAABYktHRBCVsg0sAAAAB3RJTUUH5QsZDhwdX3MVGwAAAPtJREFUaN7t2tEO
gjAMQNFpRURw/v/fCgSkm32AB0JltwbXVEZOKpGZLEQV4dC4KMk1xDSkf41D/A6Sp3Muaao//Z0/
lSWak4b3t2LcelflLu64cOFyE7jO4woOXVX98OmKTl1Dv+qjEUZ47Reuc7i473GV6PL8fJSjEUZ4
7heu/3cJz6HNLvqFqzQX61VcJbq477e76BeuPV38T1sfnr9HXOtDnLq89ovnEK4SXaxXcZXoYv21
LRz/Tnjdb4ILFy4fgetMLrWZvBEZj3lQeVpulnJ+4pQb5caYr67+zPaTL9F2bTse86DytNwt5fzE
KTfKnTFfXf2l999/AGFh+qB6fZ1mAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTExLTI1VDExOjI4
OjI5KzAzOjAwyX7YewAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0xMS0yNVQxMToyODoyOSswMzow
MLgjYMcAAAAASUVORK5CYII=" />
            </svg>
            <div class="list_container">
              <div class="img_num">
                {{item.key}}
              </div>
              <div class="list_title">
                {{item.title}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 表格部分 -->
    <div class="echart_zonglan">
      <div class="echarts_font">
        <img :src="icon_font"
             class="icon_img"
             alt="" />
        <span class="people_font">民意收集问题明细</span>
      </div>
      <div class="table_select_box">
        <span>选择村部：</span>
        <!-- 乡镇 -->
        <el-select class="selectLable"
                   v-model="query.town"
                   @change="handleTownList"
                   placeholder="请选择乡镇">
          <el-option v-for="item in optionsTown"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <!-- 村 -->
        <el-select class="selectLable"
                   v-model="query.village"
                   @change="handleVillageList"
                   placeholder="请选择村">
          <el-option v-for="item in optionsVillage"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </div>

      <!-- 表格区域 -->
      <div class="table_box"
           v-if="!detailFlag">
        <el-table :data="tableData"
                  border
                  style="width: 100%">
          <el-table-column v-if="false"
                           prop="id"
                           label="ID"
                           align="center"
                           width="180">
          </el-table-column>
          <el-table-column prop="village"
                           label="村名"
                           align="center"
                           width="100">
          </el-table-column>
          <el-table-column prop="typeLable"
                           label="类型"
                           align="center"
                           width="100">
          </el-table-column>
          <el-table-column prop="title"
                           label="标题"
                           align="center"
                           width="180">
          </el-table-column>
          <el-table-column prop="createTime"
                           label="反馈时间"
                           align="center"
                           width="180">
          </el-table-column>
          <el-table-column prop="content"
                           align="center"
                           show-overflow-tooltip
                           label="反馈内容">
          </el-table-column>
          <el-table-column align="center"
                           label="处理状态"
                           width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.processingStatus === '0'">
                未处理
              </div>
              <div v-else-if="scope.row.processingStatus === '1'">
                已处理
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center"
                           label="处理详情"
                           width="100">
            <template slot-scope="scope">
              <el-button type="text"
                         @click="handleViews(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page_fun">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="query.pageIndex"
                         :page-sizes="[10, 20, 30, 40, 50]"
                         :page-size="query.pageSize"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="totalSize">
          </el-pagination>
        </div>
      </div>

      <!-- 点击查看区域 -->
      <div class="detail_box"
           v-if="detailFlag">
        <div class="back"
             @click="backList">
          <img :src="left_back"
               class="back_img">
          <span>返回列表页</span>
        </div>
        <div>
          <StepDetail :dataList="stepList" flag="collection" />
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import CollectionNum from "../detail_cjt_echart/collection_num.vue";
import StepDetail from "./step_component/step_detail.vue";
export default {
  name: "Collection",
  components: {
    CollectionNum,
    StepDetail,
  },
  data() {
    return {
      icon_font: require("@/assets/images/icon_font.png"),
      left_back: require("@/assets/images/left_back.png"),
      tableData: [],
      // 乡镇选择列表
      optionsTown: [],
      // 村落选择列表
      optionsVillage: [],
      // 选择条件
      query: {
        // 乡镇
        town: "",
        // 村
        village: "",
        // 分页 当前页
        pageIndex: 1,
        // 每页几条
        pageSize: 10,
      },
      // 总共几条
      totalSize: 0,
      // 是否显示详情页
      detailFlag: false,

      // 民意收集问题统计
      totalData: {
        // 民意收集量
        postNumSum: 0,
        // 问题处理量
        processedNumSum: 0,
        feedbackStatisList: [],
      },
      totalText: [
        {
          title: "民意收集总统计",
        },
        {
          title: "问题处理数量总统计",
        },
      ],
      srcList: [], //预览图片列表,
      // 传入详情页的数据
      stepList: [],
      flag: false,
    };
  },
  created() {
    this.handleDataTotal();
    this.handleTownList();
  },
  mounted() {},
  methods: {
    // 返回按钮
    backList() {
      this.detailFlag = false;
    },

    // 民意收集统计接口调用
    handleDataTotal() {
      this.totalData = plOtherDataInterface.getFeedbackPostsNum();
      this.totalText.map((item) => {
        if (item.title === "民意收集总统计") {
          item.key = this.totalData.postNumSum;
        }
        if (item.title === "问题处理数量总统计") {
          item.key = this.totalData.processedNumSum;
        }
      });
    },

        // 选择村
    handleVillageList(val) {
      this.getListAndDetail(
          "",
          this.query.pageIndex,
          this.query.pageSize,
          this.query.town,
          this.query.village
        );
    },

    // 查看详情
    handleViews(row) {
      let dataDetail = this.getListAndDetail2(
        row.id,
        1,
        1,
        row.town,
        row.village
      );
      if (dataDetail["data"].length > 0) {
        this.stepList = dataDetail["data"];
        this.detailFlag = true;
      }
    },

    // 获取乡镇乡村列表
    handleTownList() {
      // 把村子置换空 再push数组
      this.query.village = "";
      this.query.optionsTown = [
        {
          label: "全部",
          value: "",
        },
      ];
      let res = plOtherDataInterface.getTownAndVillage2(this.query.town);
      if (this.query.town == "") {
        this.optionsTown = [];
        for (let i = 0; i < res.town.length; i++) {
          this.optionsTown.push({
            value: res.town[i],
            label: res.town[i],
          });
        }
        this.getListAndDetail(
          "",
          this.query.pageIndex,
          this.query.pageSize,
          this.query.town,
          this.query.village
        );
      } else {
        this.optionsVillage = [
          {
            label: "全部",
            value: "",
          },
        ];
        for (let i = 0; i < res.village.length; i++) {
          this.optionsVillage.push({
            value: res.village[i],
            label: res.village[i],
          });
        }
        this.getListAndDetail(
          "",
          this.query.pageIndex,
          this.query.pageSize,
          this.query.town,
          this.query.village
        );
      }
    },

    // 请求列表的接口方法
    getListAndDetail(id, pageIndex, pageSize, town, village) {
      const data = {
        id: id,
        // 第几页
        pageIndex: pageIndex,
        // 每页几条
        pageSize: pageSize,
        town: town,
        village: village,
      };
      let res = plOtherDataInterface.getFeedbackList(data);
      this.totalSize = res.count;
      this.tableData = res.data;
    },
    // 请求详情的方法
    getListAndDetail2(id, pageIndex, pageSize, town, village) {
      const data = {
        id: id,
        // 第几页
        pageIndex: pageIndex,
        // 每页几条
        pageSize: pageSize,
        town: town,
        village: village,
      };
      let res = plOtherDataInterface.getFeedbackList(data);
      return res;
    },

    // 当前每页几条改变
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getListAndDetail(
        "",
        this.query.pageIndex,
        this.query.pageSize,
        this.query.town,
        this.query.village
      );
    },

    // 当前页页码改变
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.getListAndDetail(
        "",
        this.query.pageIndex,
        this.query.pageSize,
        this.query.town,
        this.query.village
      );
    },
  },
};
</script>

<style lang="less" scoped>
.echart_zonglan {
  margin: 1.875rem 0 0 0;
  border-bottom: 1px dashed rgb(121, 226, 154);
  padding-top: 0.888rem;
  padding-bottom: 0.888rem;
  &:last-child {
    border-bottom: none;
  }
}

#echart_cjt_one {
  display: flex;
  .collection_line {
    margin-top: 1rem;
    width: 78%;
    height: 22rem;
  }

  .right_box {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    box-sizing: border-box;
    height: 100%;
    width: 22%;
    padding: 20px 20px 20px 8px;
    .r_list {
      position: relative;
      &:first-child {
        margin-bottom: 8px;
      }
      .border {
        position: absolute;
        top: 0;
        left: 0;
      }
      .list_container {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        width: 100%;
        height: 100%;
        z-index: 99;
        position: absolute;
        top: 0;
        left: 0;
        box-sizing: border-box;
        padding: 13px 10px 10px 10px;
        .img_num {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          width: 100%;
          overflow: hidden;
          height: 2rem;
          font-size: 2rem;
          background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKMAAAAgCAYAAAB+SMj2AAAABHNCSVQICAgIfAhkiAAABRlJREFUeF7tXLtW4zAQtc/BxRZLAwXFNtvwCfn/ahuabShoaChS4P2CUOxEyiDLHl2PRlYwiZ0DIollvcZX986MaR/7P7sGHh/NDb0+6CWVDX2eOjr64kCvjl5yiRoW6nV0nQN9TiX90dBljw0kSn8enx+XqB6Ns6PxHlAp1MeTuH2rmIH2sX/a8XqClaUF9wZwQ8UHVZDKhhawoYWUyk/7YTuKyqGBiSdw82LpDTO/XmzYcn3reN2Nsh1ZM9D+JmOUayBEY0iSa5I5mpDUX83ebhKJPxHSiqQaJN6QNMvyhJPJGP+SMSb3usEWmz4L1bcji0dYhKg1EdHaLhovb/1oB7lmRG1/OWP0RxnHw/W9waIDcVNcs6zfiJsiJGVmUIObXicnJWN8FpERaYNgGghRl0dS5qpWboqQlCHYioilnNi6g7h2S/fHldRvH/bPOz8RR3HSEdejkjCSS81QETKh+mWIRiKqGjc1InExN8VI7Nfpcrlp+9C/EDIe3TN+af1vfheXCBGD+8aGiKVIXIQsaTHuANPKTTESe8OzIrGdm64EBiUBc0fI2JE75uDEQij9VijfqQhJNYhqRVLff7vaRkjq/ajosLeb7HcxkrIfFSHq90HS9q5/dZxRh0xTzAyOcISoVm7JxjGtX4rEGEmpXTchNr+pFUnZXWqtr0Fi6w5yDpXf3u5fCBl1kQ2/pcQImo2oI05aiqQc2bFy03lOvEWgphGpARIvuOs7ZEzhltX/GPqXYp9z3LSe3xPvAOl2a0agLlHlW5C0/bF/dciIYr3+a9mfNh8jZpIuI2oZNzWq3k9SItffVP44po9VPlOadExfqC8JmNv+bRe4CnOlkcwbRGgQVytX2whJOVljyk1Ru6zCrIhYl5umOSnH+K1q21qv1N9qV/k3DSHj2y6lXqyIGE9EPqIiboqQlMfhJqQKN62DxGUqvzTytZ4IVNu8v/9cjoP+o0vd0U8o7+l9T+/v6dOefoblcu1+1ZXGIwrv41mIZ+Wrelve7nR9eWTS+vJsaNtd2BiPzaY7HJZE7t4SA9IOfLnz0gYZbj25NWSwPIvL9XOpK9nXl3uQWue26/udpOZcaHA2f5E55pT7BAf6NIARKCjipiiSw8PK8z+Wq3xbu5p8UZ2fV1D7VfNMvfis6fccUrq22fekpoft5XM8FDONHceyKivjpqi/Gi9BDZWP8z23CNQp838UgXLG6O73k0UGB3gGog0yrRGiBkTMQ9JkZGIBla9T25vKH2fwW9U6qheMMYdSnG58K6LF8l+OnSLVbG2X1ba1/npVfk0kPl8EymaMIpKGoP34kZQkR+S0tQQ3RUga/HCc3KFAciWS6jgeP2Q25bbl3NQWgQrtWnMB0vV0GqIslm83xhwkPZ2LuGlMkmVuOc9NESfFmdnfLQI1H1O3+x+/KgJ1VmNcgpvq7tDvpfIDEltj+WmVr+PENiTV7CA5WULnN8YMRF1G5fNjtTE3ra/yS5E4X+XXjEDVRGKOQK3aGLVIOhtbL+CmyF+abFfJTcs5Hl9hPXmmJUi8fmPMQFI+dV4ty/7H+ipf4/fM9/MukmdqfgbKngE/5qYXaYxaRLWqfN1TipvKHzNRnB/bNJdrjCKiyv64+iqf/+VLrPZLObF1B4j9rfnctNYzUFdmjGDPv9IIlC5f8zwRqM0YDZy0NJJTn5vW9LfmI6lW5W/GaDFGZSy/psrXZYKzv/WUHaVU+Rr/oS7LKE/l/wc6wKiRyprZOwAAAABJRU5ErkJggg==");
        }
        .list_title {
          font-size: 1rem;
           line-height:1;
          color: #ffffff;
        }
      }
    }
  }
}

.detail_box {
  .back {
    height: 30px;
    color: #3ef89c;
    font-size: 22px;
    margin-bottom: 30px;
    cursor: pointer;
    .back_img {
      height: 100%;
    }
  }
}

#echart_cjt_one {
  align-items: center;
}
.compantBtn {
  position: absolute;
  right: 5%;
  top: 0;
}

.echarts_font {
  text-align: left;
}
.icon_img {
  width: 25px;
  height: 25px;
  margin-right: 0.4375rem;
  vertical-align: sub;
}
.people_font {
  font-size: 24px;
  color: rgb(62, 248, 156);
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}

.companySelect {
  padding-top: 2rem;
}
// // 下拉选择框样式
.selectLable {
  width: 90px;
  height: 25px;
  font-size: 16px;
  font-family: PingFang-SC-Medium;
  text-align: center;
  color: #ffffff;
  line-height: 30px;
  margin-right: 5px;
}
.el-select {
  width: 151px;
  border-radius: 4px;
}

.el-select,
/deep/ .el-input,
/deep/ .el-input__inner {
  background: #39819a;
  text-align: center;
  color: ghostwhite;
  border-color: #39819a;
  border-radius: 4px;
  font-size: 16px;
  height: 30px;
  ::-webkit-input-placeholder {
    color: #ffffff;
  }
  ::-moz-input-placeholder {
    color: #ffffff;
  }
  ::-ms-input-placeholder {
    color: #ffffff;
  }
}

// 表格 联动选择框
.table_select_box {
  display: flex;
  justify-content: flex-end;
  margin-top: 27px;
  margin-bottom: 50px;
  span {
    color: #ffffff;
    font-size: 18px;
  }
}

// 表格样式
.table_box {
  /deep/ .el-table {
    border: 1px solid #3a6c83;
  }
  /deep/ .el-table--border td {
    border-color: #3a6c83;
    color: #ffffff;
  }
  /deep/ .el-button--text {
    color: #ffffff;
    :hover {
      color: #55f8ff;
    }
  }

  /deep/ .el-table::before,
  .el-table::after {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0px;
  }

  /deep/ .el-table,
  /deep/.el-table__expanded-cell {
    background-color: transparent !important;
  }
  /deep/ .el-table tr,
  /deep/ .el-table td {
    background-color: transparent !important;
    &:last-child {
      border-right: none;
    }
  }
  /deep/ .el-table th {
    background-color: #0d5064 !important;
    border-bottom-color: transparent;
    border-right-color: transparent;
    color: #1eeabe;
  }
}

.el-select /deep/ .el-select-dropdown__item.selected {
  color: rgb(62, 248, 156);
}
.el-select /deep/ .el-select__caret {
  /*很关键：将默认的select选择框样式清除*/
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  /*为下拉小箭头留出一点位置，避免被文字覆盖*/
  /*自定义图片*/
  background: url("../../../assets/icon/selectIcon.png") no-repeat scroll right
    center transparent;
  /*自定义图片的大小*/
  background-size: 12px 12px;
}
/*将小箭头的样式去去掉*/
.el-select /deep/ .el-icon-arrow-up:before {
  content: "";
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.btnBox {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}
.btn {
  width: 160px;
  height: 30px;
  background: rgba(18, 87, 123, 0.6);
  border: 1px solid #00ffce;
  text-align: center;
  cursor: pointer;
  margin-right: 13px;
}
.activeBtn {
  width: 160px;
  height: 30px;
  background: linear-gradient(0deg, #2dbcdd, #09809c 78%, #2dbcdd);
  border: 1px solid #00ffff;
  text-align: center;
  cursor: pointer;
  margin-right: 13px;
}
.btnTitle {
  font-size: 16px;
  font-family: inpinheiti;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 2px;
}
.companyText {
  margin-top: 22px;
  word-break: break-all;
  width: 930px;
  height: auto;
  margin: 0 auto;
}
.companyImg {
  width: 384px;
  height: 289px;
  float: left;
  margin-right: 30px;
}
.companyP {
  font-size: 16px;
  font-family: AdobeHeitiStd-Regular;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 0px;
}
.table_box {
  padding: 0 30px;
}

.page_fun {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

/deep/ .el-pagination .el-pagination__total {
  color: #FFFFFF;
 
}
 /deep/ .el-pager li{
    background-color: #15606e;
     color: #FFFFFF;
  }
  /deep/ .el-pager .active{
    color: #409EFF !important;
  }
  /deep/ .el-pagination__jump {
    color: #ffffff;
  }

/deep/ .el-pagination button:disabled {
  background-color: #15606e;
}

/deep/ .el-pagination .btn-next,
/deep/ .el-pagination .btn-prev {
  background-color: #15606e !important;
  color: #FFFFFF;
}

</style>


// WEBPACK FOOTER //
// src/components/rightAside/detail_cjt/collection.vue